export const CONFIRMATION_STEP_ROUTE = 'potwierdzenie';

export const CONFIRMATION_STEP_PARAMETRIZED_ROUTE = 'potwierdzenie/:resId';
